import { ReviewCountTypography, Typography } from '@musinsa/mds';
import type { FC } from 'react';

const DISPLAY_NAME = 'ProductInformation.ReviewCount';

interface Props {
  reviewCount?: number;
}

export const ReviewCount: FC<Props> = ({ reviewCount }) => (
  <Typography variant="textEtc11pxReg" colorScheme="yellow">
    ({reviewCount ? <ReviewCountTypography reviewCount={reviewCount} /> : 0})
  </Typography>
);

ReviewCount.displayName = DISPLAY_NAME;
